module.exports = __webpack_public_path__ + "img/awesome-linkedin.208520c3.svg";